import type { ComponentType } from "react";
import { Navigate } from "react-router-dom";
import { getToken } from "@/lib/utils";

interface ConditionalRouteProps {
  component: ComponentType;
  isPrivate?: boolean;
}

const ConditionalRoute = ({ component: Component, isPrivate = false }: ConditionalRouteProps) => {
  const isAuthenticated = !!getToken();

  if (isPrivate && !isAuthenticated) {
    return <Navigate to="/login" />;
  } else if (!isPrivate && isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }
  return <Component />;
};

export default ConditionalRoute;
